import type { SearchableComboboxOption } from "@/components/ui/searchable-combobox"

export type CatalogModelOptionSource = {
  id: string
  label: string
  enabled?: boolean
  platform_disabled?: boolean
}

export function catalogModelComboboxOption(
  model: CatalogModelOptionSource,
  platformDisabledLabel: string,
): SearchableComboboxOption {
  return {
    value: model.id,
    label: model.label,
    disabled: model.enabled === false,
    disabledHint: model.platform_disabled ? platformDisabledLabel : undefined,
  }
}
